// hooks/useApi.js
import { useCallback, useState } from 'react';

// Get token from environment variable (build-time) or a constant
import { useSession } from "../components/SessionProvider";

// hooks/useApi.js
export const useApi = () => {
    const apiUrl = import.meta.env.VITE_API_URL_MAIN;
    const { userLogin } = useSession();
    const token = userLogin.session_token;

    const apiCall = useCallback(async (command, options = {}) => {
        const {
            method = 'GET',
            params = {},
            body = null,
            headers = {},
        } = options;

        const isPost = ['POST', 'PUT', 'PATCH'].includes(method);

        const urlParams = new URLSearchParams({
            command,
            ...(!isPost ? params : {}),
        });

        const url = `${apiUrl}${urlParams.toString()}`;

        const fetchOptions = {
            method,
            credentials: 'include',
            headers: {
                'X-API-TOKEN': token,
                'X-API-EMAIL': userLogin.user_email ?? '',
                ...headers,
            },
        };

        if (isPost) {
            const postData = {
                ...params,
                ...(body || {}),
            };

            if (body instanceof FormData) {
                fetchOptions.body = body;
            } else {
                fetchOptions.headers['Content-Type'] = 'application/json';
                fetchOptions.body = JSON.stringify(postData);
            }
        }

        const response = await fetch(url, fetchOptions);

        if (!response.ok) {
            throw new Error(`API error: ${response.status}`);
        }

        return response;
    }, [apiUrl, token, userLogin.user_email]);

    return { apiCall };
}